import React from 'react'
import PropTypes from 'prop-types'
import { image } from 'services'

import { bannerStyles } from './styles'

const Banner = ({ title, subTitle, imageSrc, description }) => (
  <div className="banner-container">
    {title && (
      <h5 className="title">
        <strong>{title}</strong>
      </h5>
    )}
    <div className="banner">
      <img src={image(imageSrc)} alt="" />
      <div>
        {subTitle && (
          <p className="subtitle">
            <strong>{subTitle}</strong>
          </p>
        )}
        <p className="description">{description}</p>
      </div>
    </div>
    <style jsx>{bannerStyles}</style>
  </div>
)

Banner.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  imageSrc: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
}

export default Banner
